import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
export function Bonuses() {
  return <section className="w-full bg-mist px-5 py-16 sm:py-24" aria-label="Exclusive professional bonuses" data-id="element-65" data-mp="aua82hmprpv5">
      <div className="mx-auto max-w-6xl" data-id="element-66" data-mp="fsv7ieu565ij">
        <SectionHeading eyebrow="Exclusive professional bonuses — included free" title="5 Additional Resources to Help You Put the Pathway Into Practice" intro="These five bonuses complement the six core volumes with additional tools for organizing observations, examining motor performance, and practicing your reasoning." data-id="element-67" data-mp="1uertyeax4o9" />

        <div className="mt-12 space-y-14 lg:space-y-20" data-id="element-68" data-mp="3t180tofc683c">
          {bonuses.map((b, i) => <article key={b.number} className="lg:grid lg:grid-cols-2 lg:items-center lg:gap-14" data-id="element-69" data-mp="1marurq0iee4l" data-mpi={i}>
              <div className={i % 2 === 1 ? 'lg:order-2' : ''} data-id="element-70" data-mp="1r8tca6iae5dy">
                <img src={b.image} alt={`Bonus ${b.number}: ${b.title}`} className="-mx-5 block w-[calc(100%+2.5rem)] max-w-none sm:mx-auto sm:w-full sm:max-w-xl" data-id="element-71" data-mp="3idwsbuwctwqi" />
              </div>

              <div className="mt-6 lg:mt-0" data-id="element-72" data-mp="3r8ujoxjut1fq">
                <div className="flex flex-wrap items-center gap-3" data-id="element-73" data-mp="3n4wkynyfxsn7">
                  <span className="rounded-full px-4 py-1.5 text-sm font-extrabold uppercase tracking-wide text-white" style={{
                backgroundColor: b.color
              }} data-id="element-74" data-mp="2zfkg20a5c6qp">
                    Bonus #{b.number}
                  </span>
                  <span className="text-sm font-semibold text-ink/60" data-id="element-75" data-mp="38gs13gnnjb2u">
                    Value <s className="text-danger" data-id="element-76" data-mp="33h5mp3w37osg">USD ${b.value}</s>
                  </span>
                  <span className="rounded-full bg-ok px-3 py-1 text-xs font-extrabold uppercase text-white" data-id="element-77" data-mp="33jifyd7aplkt">Included free</span>
                </div>
                <h3 className="mt-4 font-heading text-[1.6rem] font-semibold leading-tight text-ink sm:text-3xl" data-id="element-78" data-mp="ipwtx6x7a415">{b.title}</h3>
                <p className="mt-3 leading-relaxed text-ink/75" data-id="element-79" data-mp="3cimzmxobn4bc">{b.intro}</p>
                <p className="mt-5 font-semibold text-ink" data-id="element-80" data-mp="3hgy6czjbkypc">{b.listLabel}</p>
                <ul className="mt-3 grid gap-x-5 gap-y-2 sm:grid-cols-2" data-id="element-81" data-mp="3lj33i88z8dgq">
                  {b.list.map(item => <li key={item} className="flex gap-2.5 leading-snug text-ink/80" data-id="element-82" data-mp="3qhmpg8nklp93">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0" style={{
                  color: b.color
                }} aria-hidden="true" data-id="element-83" data-mp="2tt81bb00stan" />
                      <span data-id="element-84" data-mp="2xutjnbvbpzs8">{item}</span>
                    </li>)}
                </ul>
                <p className="mt-5 text-[0.95rem] italic leading-relaxed text-ink/65" data-id="element-85" data-mp="32sbmqlmntksb">{b.closing}</p>
              </div>
            </article>)}
        </div>
        <SectionCta label="Yes, I want all 5 bonuses" data-id="element-86" data-mp="2a4zap5e4kvd9" />
      </div>
    </section>;
}